import React, { useState, useContext } from "react";

const UpdateTimeSlotContext = React.createContext();

const useUpdateTimeSlot = () => useContext(UpdateTimeSlotContext);

const UpdateTimeSlotProvider = ({ children }) => {
  const [updateTimeSlot, setUpdateTimeSlot] = useState(false);

  return (
    <UpdateTimeSlotContext.Provider
      value={{ updateTimeSlot, setUpdateTimeSlot }}
    >
      {children}
    </UpdateTimeSlotContext.Provider>
  );
};

export { useUpdateTimeSlot, UpdateTimeSlotProvider };
